import { VodafoneTariffState } from '@tymbe/schema/enums';
import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const activeVodafoneTariffQueryId = 'admin/vodafoneTariff/active';

export const ActiveTab = () => {
  return (
    <VodafoneTariffTable
      queryId={activeVodafoneTariffQueryId}
      state={VodafoneTariffState.ACTIVE}
      tabName="active"
    />
  );
};
